import { ComponentProps, JSXElementConstructor } from 'react';
import { registerModals } from '@bonanza-social/navigation';
import MarketingOptOutModal from './MarketingOptOutModal/MarketingOptOutModal';
import SocialRegistrationModal from './SocialRegistrationModal/SocialRegistrationModal';
import { RAFTermsScreen } from '../../screens';

const modals = {
  RAFTerms: RAFTermsScreen,
  MarketingOptOutModal,
  SocialRegistrationModal,
};

registerModals('registration', modals);

declare global {
  interface RegisteredModals {
    registration: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}
